<div class="info">
  <div *ngFor="let group of groups;">
    <div class="title" (click)="toggleAccordian(group)" [class.open]="!group.open">
      <div inlineSVG="sot/sot-icon.svg#sot-forward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
      <span [langkey]="group.langkey"></span>*
      <ng-container *ngIf="group.header && group.header.length>0">
        <span class="header">{{group.header}}</span>*
      </ng-container>
    </div>
    <div class="properties">
      <ul>
        <ng-container *ngFor="let property of group.properties">
          <li [class.hyphen-content--none]="group.langkey==='details_distributor'">
            {{property}}
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
  <div *ngIf="groups.length > 0">
    <span langkey="details_hint"></span><!--*Angaben beziehen sich auf nicht personalisierte Bestellungen.-->
  </div>
</div>